import { useMemo } from 'react';
import { getComponents } from './getComponents.js';

function useOverrides(defaultComponents, overrides) {
    const components = useMemo(()=>getComponents(defaultComponents, overrides), [
        defaultComponents,
        overrides
    ]);
    return components;
}

export { useOverrides };
